module.exports = __webpack_public_path__ + "media/application/images/ui/icon-instagram-94e38a3c129ba5bc0cd546a63eebef88.png";